// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__zlmjw","crumb":"Breadcrumbs_crumb__3hiE9"};